import { SvgIcon, SvgIconProps } from '@mui/material';

/** @deprecated Use theme-next icons or move into theme-next folder if it doesn't exists */
export const StarIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props} viewBox="0 0 20 20">
            <path
                d="M12.5751 6.88334L10.0001 1.66667L7.42508 6.88334L1.66675 7.725L5.83342 11.7833L4.85008 17.5167L10.0001 14.8083L15.1501 17.5167L14.1667 11.7833L18.3334 7.725L12.5751 6.88334Z"
                fill="none"
                stroke={props.color ? 'currentColor' : props.htmlColor ?? '#21272E'}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </SvgIcon>
    );
};
